/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import r from '../../../util/Renderer'
import { EditViewLayout } from 'ui-library/dist/external/layouts'
import { Checkbox, ContainedButton, EditArea, EditContainer, EditField, EditTitleBar, NormalButton, TextArea, TextInput } from 'ui-library/dist/external/components'
import Money from '../../unit/Money'
import AccommodationInvoiceAction from '../../../action/accommodation_invoice'
import ReservationAction from '../../../action/reservation'

function CreateView(props) {
  const reservation_id = props.match.params.id
  const enableSubmit = props.view.accommodation_fee_paid || props.view.accommodation_tax_paid
  return (
    <EditViewLayout>
      <EditContainer
        titleBar={<EditTitleBar title={`請求書発行 [予約ID:${reservation_id}]`} />}
        editAreaTabs={[]}
        editArea={<EditArea fields={EditAreaFields(props)} />}
        footerItems={[
          <NormalButton key="cancel" onClick={ReservationAction.cancelCreationView}>
            キャンセル
          </NormalButton>,
          <ContainedButton
            key="save"
            disabled={!enableSubmit}
            onClick={() => {
              if (window.confirm('請求書を発行すると請求書がお客様に送信されます。実行しますか？')) {
                AccommodationInvoiceAction.requestSave(reservation_id, props.accommodation_tax, props.view)
              }
            }}
          >
            請求書発行
          </ContainedButton>
        ]}
      >
        <EditField key="選択">
          <>
            <Checkbox
              nativeControlId="fee"
              name="accommodation_fee_paid"
              checked={props.view.accommodation_fee_paid}
              onChange={e => AccommodationInvoiceAction.onEdit(props.reservation, 'accommodation_fee_paid', e.currentTarget.checked)}
            />
            <label htmlFor="fee">宿泊費</label>
            <Checkbox
              nativeControlId="tax"
              name="accommodation_tax_paid"
              checked={props.view.accommodation_tax_paid}
              onChange={e => AccommodationInvoiceAction.onEdit(props.reservation, 'accommodation_tax_paid', e.currentTarget.checked)}
            />
            <label htmlFor="tax">宿泊税</label>
          </>
        </EditField>

        {r.renderIf(props.view.accommodation_fee_paid)(
          <EditField key={`明細#1`}>
            <TextInput
              label="宿泊費"
              leadingIcon={'money'}
              fullWidth
              value={props.view.accommodation_fee}
              onChange={e => AccommodationInvoiceAction.onEdit(props.reservation, 'accommodation_fee', e.currentTarget.value)}
            />
          </EditField>
        )}
        {r.renderIf(props.view.accommodation_tax_paid)(
          <EditField key={`明細#2`}>
            <TextInput label="宿泊税" leadingIcon={'money'} fullWidth value={props.view.accommodation_tax} />
          </EditField>
        )}

        <EditField key="備考">
          <TextArea label="備考" fullWidth value={props.view.note} onChange={e => AccommodationInvoiceAction.onEdit(props.reservation, 'note', e.currentTarget.value)} />
        </EditField>
      </EditContainer>
    </EditViewLayout>
  )
}

function EditAreaFields(props) {
  if (props.view.accommodation_tax_paid) {
    return [
      <EditField key="宿泊税計算額">
        <>
          <small>宿泊税計算額</small>
          <h3>
            <Money>{props.accommodation_tax.calculate()}</Money>&nbsp;&nbsp;
            <small>
              (<Money>{props.accommodation_tax.calculatePerPersonAndDay()}</Money>/人日)
            </small>
          </h3>
        </>
      </EditField>,
      <EditField key="宿泊料金">
        <TextInput
          label="宿泊料金 (宿泊税計算)"
          leadingIcon={'money'}
          halfWidth
          value={props.accommodation_tax.accommodation_fee_include_tax}
          onChange={e => AccommodationInvoiceAction.onEditAccommodationTax(props.reservation, 'accommodation_fee_include_tax', e.currentTarget.value)}
        />
        <>
          <Checkbox
            nativeControlId="include_commission"
            name="ota_commission_include"
            checked={props.accommodation_tax.ota_commission_include}
            onChange={e => AccommodationInvoiceAction.onEditAccommodationTax(props.reservation, 'ota_commission_include', e.currentTarget.checked)}
          />
          <label htmlFor="include_commission">OTA手数料を含める</label>
        </>
      </EditField>,
      <EditField key="手数料">
        <TextInput
          label="OTA手数料 (金額)"
          leadingIcon={'monetization_on'}
          halfWidth
          value={props.accommodation_tax.payment_commission}
          onChange={e => AccommodationInvoiceAction.onEditAccommodationTax(props.reservation, 'payment_commission', e.currentTarget.value)}
        />
        <TextInput
          label="OTA手数料率 (%)"
          leadingIcon={'check_circle_outline'}
          halfWidth
          value={props.accommodation_tax.ota_commission_rate}
          onChange={e => AccommodationInvoiceAction.onEditAccommodationTax(props.reservation, 'ota_commission_rate', e.currentTarget.value)}
        />
      </EditField>,
      <EditField key="滞在日数">
        <TextInput
          label="滞在日数 (宿泊税計算)"
          leadingIcon={'today'}
          halfWidth
          value={props.accommodation_tax.number_of_nights}
          onChange={e => AccommodationInvoiceAction.onEditAccommodationTax(props.reservation, 'number_of_nights', e.currentTarget.value)}
        />
        <TextInput
          label="人数 (宿泊税計算)"
          leadingIcon={'people'}
          halfWidth
          value={props.accommodation_tax.number_of_guests}
          onChange={e => AccommodationInvoiceAction.onEditAccommodationTax(props.reservation, 'number_of_guests', e.currentTarget.value)}
        />
      </EditField>,
      <br />,
      <br />,
      <br />
    ]
  }

  return []
}

export default CreateView
